<div class="statistics-table-wrapper" [ngClass]="isDashboardRoute ? 'widget-table' : ''">
  <app-table-header
    *ngIf="!widgetMode"
    [widgetMode]="widgetMode ?? false"
    [title]="title"
    [campaignsListLength]="pagination?.total"
    [isExpandable]="isExpandable"
    [columnManagementOptions]="columnManagementOptions"
    [filteredDataLength]="filteredDataLength"
    [sortDropdownValues]="sortDropdownValues"
    [choosenSortMethod]="activeSortMethod"
    [appliedFiltersBar]="appliedFiltersBar">
  </app-table-header>
  <div class="appiled-filters" *ngIf="widgetMode && Object.keys(appliedFiltersBar).length">
    <app-filters-bar [appliedFiltersBar]="appliedFiltersBar"></app-filters-bar>
  </div>
  <ng-container *ngIf="!widgetMode; else infiniteScroll">
    <div [ngStyle]="{'min-height.px': openedColumMenuHeight + 100}" class="table-wrapper" [ngClass]="!isDashboardRoute ? 'minHeight' : ''">
      <table class="table">
        <thead class="table-options" [ngClass]="{'d-none': statisticsData?.length === 0 && loadTableDataOnPageChange}">
          <tr
            id="table-columns"
            table-columns
            [columnManagementOptions]="columnManagementOptions"
            [statisticsData]="statisticsData"
            [title]="title"
            [currency]="currency"
            [filterMenuOptions]="filterMenuOptions"
            [appliedFiltersBar]="appliedFiltersBar"
            (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)"></tr>
        </thead>
        <div *ngIf="!loadTableDataOnPageChange" class="loader-wrapper">
          <app-loader></app-loader>
        </div>
        <div *ngIf="statisticsData?.length === 0 && loadTableDataOnPageChange" class="noData-wrapper">
          <ng-container [ngSwitch]="title">
            <ng-container *ngSwitchCase="'referrals'">
              <app-join-program-alert
                class="offer-join-alert"
                [type]="'info'"
                [containerText]="{withTranslation: true, text: 'redirect_referrals_title'}"
                [containerTextDesc]="{withTranslation: true, text: 'redirect_referrals_text'}"
                [buttonText]="'redirect_referrals_button'"
                [redirectButton]="true"
                (redirectAction)="redirectHandler('referrals')"></app-join-program-alert>
            </ng-container>

            <ng-container *ngSwitchCase="'smartlinks_stats'">
              <app-join-program-alert
                class="offer-join-alert"
                [type]="'info'"
                [containerText]="{withTranslation: true, text: 'redirect_smartlinks_title'}"
                [containerTextDesc]="{withTranslation: true, text: 'redirect_smartlinks_text'}"
                [buttonText]="'redirect_smartlinks_button'"
                [redirectButton]="true"
                (redirectAction)="redirectHandler('smartlinks')"></app-join-program-alert>
            </ng-container>

            <ng-container *ngSwitchCase="'incent_campaigns_stats'">
              <app-join-program-alert
                class="offer-join-alert"
                [type]="'info'"
                [containerText]="{withTranslation: true, text: 'redirect_incent_title'}"
                [containerTextDesc]="{withTranslation: true, text: 'redirect_incent_text'}"
                [buttonText]="'redirect_incent_button'"
                [redirectButton]="true"
                (redirectAction)="redirectHandler('incent')"></app-join-program-alert>
            </ng-container>

            <ng-container *ngSwitchCase="'hidelink'">
              <app-join-program-alert
                class="offer-join-alert"
                [type]="'info'"
                [containerText]="{withTranslation: true, text: 'redirect_hidelink_title'}"
                [containerTextDesc]="{withTranslation: true, text: 'redirect_hidelink_text'}"
                [buttonText]="'redirect_hidelink_button'"
                [redirectButton]="true"
                (redirectAction)="redirectHandler('hidelink')"></app-join-program-alert>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <app-join-program-alert
                class="offer-join-alert"
                [type]="'info'"
                [containerText]="{withTranslation: true, text: 'no_results'}"></app-join-program-alert>
            </ng-container>
          </ng-container>
        </div>
        <tbody *ngIf="statisticsData?.length > 0 && loadTableDataOnPageChange" class="table-body">
          <tr
            *ngFor="let campaign of statisticsData; index as i"
            [ngClass]="{'isDetailsLayout' : isDetailsTableLayout}"
            class="p-0 table-item"
            table-item
            [campaign]="campaign"
            [statisticsCompareData]="statisticsCompareData"
            [title]="title"
            [datesDifference]="datesDifference"
            [compareToCurrentDatesDifference]="compareToCurrentDatesDifference"
            [paramToCompare]="paramToCompare"
            [compareMode]="compareMode"
            [index]="i"></tr>
        </tbody>
      </table>
    </div>
  </ng-container>
  <ng-template #infiniteScroll>
    <div
      [ngStyle]="{'min-height.px': openedColumMenuHeight + 100, 'height.px': this.listHeight}"
      class="table-wrapper"
      [id]="'list-wrapper-' + title"
      [style.height.px]="listHeight"
      infiniteScroll
      [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollThrottle]="throttle"
      (scrolled)="onScroll()"
      (scroll)="maskVisibleHandler()"
      [scrollWindow]="false">
      <table class="table">
        <thead class="table-options" [ngClass]="{'d-none': statisticsData?.length === 0 && loadTableDataOnPageChange}">
          <tr
            id="table-columns"
            table-columns
            [columnManagementOptions]="columnManagementOptions"
            [statisticsData]="statisticsData"
            [title]="title"
            [currency]="currency"
            [filterMenuOptions]="filterMenuOptions"
            [appliedFiltersBar]="appliedFiltersBar"
            (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)"></tr>
        </thead>
        <!--        <div *ngIf="!loadTableDataOnPageChange" class="loader-wrapper">-->
        <!--          <app-loader></app-loader>-->
        <!--        </div>-->
        <div *ngIf="statisticsData?.length === 0 && loadTableDataOnPageChange" class="noData-wrapper">
          <app-join-program-alert
            class="offer-join-alert"
            [type]="'info'"
            [containerText]="{withTranslation: true, text: 'no_results'}"></app-join-program-alert>
        </div>
        <tbody *ngIf="statisticsData?.length > 0 && loadTableDataOnPageChange" class="table-body">
          <tr
            *ngFor="let campaign of statisticsData; index as i"
            [ngClass]="{'isDetailsLayout' : isDetailsTableLayout}"
            class="p-0 table-item"
            table-item
            [campaign]="campaign"
            [statisticsCompareData]="statisticsCompareData"
            [title]="title"
            [datesDifference]="datesDifference"
            [compareToCurrentDatesDifference]="compareToCurrentDatesDifference"
            [paramToCompare]="paramToCompare"
            [compareMode]="compareMode"
            [index]="i"></tr>
        </tbody>
      </table>
      <div class="bottom-mask" *ngIf="!scrolledToBottom && statisticsData">
        <!--        <app-loader-for-list *ngIf="loadingNextPage"></app-loader-for-list>-->
        <app-loader-for-list *ngIf="loadingNextPage"></app-loader-for-list>
      </div>
    </div>
  </ng-template>
  <!--  <app-global-pagination-component-->
  <!--    *ngIf="(pagination?.total_pages ?? 1) > 1"-->
  <!--    [page]="page"-->
  <!--    [pageSize]="pageSize"-->
  <!--    [pagination]="pagination"-->
  <!--    [inputPage]="page"-->
  <!--    (emitPageChange)="pageChange($event)">-->
  <!--  </app-global-pagination-component>-->
  <div class="display-options-wrapper" *ngIf="!widgetMode && pagination && pagination.total">
    <div class="total" [ngSwitch]="title">
      <ng-container *ngSwitchCase="'leads'">
        <h3>{{'total_of_rates' | t}}: {{countTotalForLeads()}}</h3>
        <!-- <ng-container *ngIf="countTotalForLeadsAdditionalData().deposit || countTotalForLeadsAdditionalData().ngr || countTotalForLeadsAdditionalData().turnover"> -->
        <ng-container *ngIf="isAdditionalDataVisible">
          <h3>{{'total_of_deposit' | t}}: {{countTotalForLeadsAdditionalData().deposit}}</h3>
          <h3>{{'total_of_ngr' | t}}: {{countTotalForLeadsAdditionalData().ngr}}</h3>
          <h3>{{'total_of_turnover' | t}}: {{countTotalForLeadsAdditionalData().turnover}}</h3>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'configuration_stats'">
        <h3>{{'total_of_earnings' | t}}: {{countTotalForPrograms()}}</h3>
      </ng-container>
      <ng-container *ngSwitchCase="'campaigns_details_stats'">
        <h3>{{'total_of_earnings' | t}}: {{countTotalForCampaigns()}}</h3>
      </ng-container>
    </div>

    <app-display-options
      [page]="pagination.current_page"
      [pageSize]="pagination.per_page"
      [pagination]="pagination"
      [numberOfItems]="numberOfItems"
      [positionsStart]="shownPositionsFrom"
      [positionsEnd]="shownPositionsTo"
      [valuesForDropdown]="perPageValues"
      [onlyNumbers]="true"
      (emitPageChange)="setPage($event)"
      (emitItemsPerPageChange)="setItemsPerPage($event)">
    </app-display-options>
  </div>
</div>
